import { render, staticRenderFns } from "./Edit_customer_point.vue?vue&type=template&id=327e871b&scoped=true&"
import script from "./Edit_customer_point.vue?vue&type=script&lang=js&"
export * from "./Edit_customer_point.vue?vue&type=script&lang=js&"
import style0 from "./Edit_customer_point.vue?vue&type=style&index=0&id=327e871b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e871b",
  null
  
)

export default component.exports